<template>
  <div class="shop-more">
    <a :href="url" target="_blank" class="link-sm link-custom" @click="handleClick">
      {{ label }}
      <span class="chevron-medium-right-black icon"></span>
    </a>
  </div>
</template>

<script setup>
/* istanbul ignore file */
import useOncePerSession from '~/composables/utils/useOncePerSession';
import { tagShopMoreLinkClick } from '~/features/analytics/shopMore';

defineProps({
  url: {
    type: String,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
});

const { hasBeenUsed } = useOncePerSession('shop-more:link-clicked');

function handleClick() {
  if (!hasBeenUsed.value) {
    tagShopMoreLinkClick();
    hasBeenUsed.value = true;
  }
}
</script>

<style lang="scss" scoped brand="mcom">
@import '~settingSCSS';

.shop-more {
  display: flex;
}

.link-custom {
  position: relative;
  padding-top: rem-calc(15);
  padding-right: rem-calc(44);
  padding-bottom: rem-calc(15);
  padding-left: rem-calc(16);
  background-color: $background-color;
  text-decoration: none;
  border-radius: rem-calc(5);

  .icon {
    position: absolute;
    top: calc(50% - rem-calc(12));
    right: rem-calc(16);
  }
}
</style>
